import { StrikeProps } from './Strike.props';

const Strike = (props: StrikeProps) => {
  const { classes, enabled, isValidNumber, value } = props;

  // If the cell is not enabled but the number is valid, show the strike style
  if (!enabled && isValidNumber) {
    return <span className={classes.strike}>{value}</span>;
  }

  // Otherwise, just render the value
  return <span>{value}</span>;
};

export default Strike;
